<template>
  <div class="owc-video-player-thumbnail">
    <GenericImage
      v-if="imageData"
      :component-id="thumbnailId"
      :imageData="imageData"
      class="owc-video-player-thumbnail__image"
    >
    </GenericImage>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import GenericImage from '@owc-packages/GenericImage/src/GenericImage.vue';
import GenericImageGenerator from '@owc-utils/GenericImage/GenericImageGenerator';
import { ThumbnailComponent } from './VideoPlayer';
/**
 * `VideoPlayer Thumbnail` - Contains the image when the video is stopped or not playing.
 */
export default (Vue as ThumbnailComponent).extend({
  name: 'owc-video-player-thumbnail',
  props: {
    thumbnailId: {
      type: String,
      required: false,
    },
    thumbnailData: {
      type: Object,
      required: false,
    },
  },
  components: {
    GenericImage,
  },
  computed: {
    imageData: function() {
      return this.thumbnailData ? new GenericImageGenerator(this.thumbnailData) : null;
    },
  },
});
</script>

<style lang="scss">
.owc-video-player-thumbnail {
  &::after {
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    background: $wb-black;
    opacity: 0.6;

    content: '';
  }
  &__image {
    position: relative;

    width: 100%;
    height: 100%;
  }
}
</style>
